import { MAIL_VIEWS } from "../../../../constants.js";
import { MailAction, MailMessageForm } from "../../../../components/MailMessageForm/index.js";
import { useMailMessageProvider } from "../../../hooks/useMailMessageProvider.js";
import { MailMessageThread } from "../../../../components/MailMessageThread/index.js";
import { useEffect, useMemo, useRef } from "react";
import { Button, ButtonGroup, Icon, Loading } from "@therms/atalaya";
import { IoClose } from "react-icons/io5";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { MdDeleteForever, MdForward, MdMarkAsUnread } from "react-icons/md";
import { BsReplyAllFill, BsReplyFill } from "react-icons/bs";
import { HiChevronLeft } from "react-icons/hi";
import { HiFlag } from "react-icons/hi2";
// src/modules/Mail/screens/MailSidebarScreen/components/MailMessageDisplay/index.tsx
var MailMessageDisplay = ({ messageId, onBack, onDeleteMessage }) => {
	const { deleteMessage, deletingMessage, flagMessage, linkedMessages, loadingMessage: loading, loadingThreadData, mailAction, mailMessage, readMessage, responseData, setMailAction, threadData, updatingFlagged, updatingUserRead } = useMailMessageProvider({ mailMessageId: messageId });
	const actionRef = useRef(null);
	const threadMessagesIds = useMemo(() => {
		return threadData?.mailMessages.map((message) => message.id) || [];
	}, [threadData]);
	useEffect(() => {
		if (mailAction && actionRef.current) actionRef.current.scrollIntoView({ behavior: "smooth" });
	}, [mailAction]);
	if ((loading || loadingThreadData) && !threadData) return /* @__PURE__ */ jsx(Loading, { overlay: true });
	if (!messageId || !mailMessage || !threadData) return null;
	const { fileUrls, subject, threadId, userFlagged, userFolder, userRead } = mailMessage;
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [
		deletingMessage && /* @__PURE__ */ jsx(Loading, { overlay: true }),
		/* @__PURE__ */ jsxs("div", {
			className: "z-sticky mb-sm bg-surface-subtle sticky top-0",
			role: "toolbar",
			children: [/* @__PURE__ */ jsxs("div", {
				className: "flex justify-between",
				children: [/* @__PURE__ */ jsxs(Button, {
					className: "space-x-xxs flex items-center",
					onClick: onBack,
					subtle: true,
					children: [
						/* @__PURE__ */ jsx(Icon, { Icon: HiChevronLeft }),
						" ",
						/* @__PURE__ */ jsx("span", { children: "Back" })
					]
				}), /* @__PURE__ */ jsxs(ButtonGroup, { children: [
					/* @__PURE__ */ jsx(Button, {
						subtle: true,
						onClick: () => setMailAction(MailAction.Reply),
						children: /* @__PURE__ */ jsx(Icon, { Icon: BsReplyFill })
					}),
					/* @__PURE__ */ jsx(Button, {
						subtle: true,
						onClick: () => setMailAction(MailAction.ReplyAll),
						children: /* @__PURE__ */ jsx(Icon, { Icon: BsReplyAllFill })
					}),
					/* @__PURE__ */ jsx(Button, {
						subtle: true,
						onClick: () => setMailAction(MailAction.Forward),
						children: /* @__PURE__ */ jsx(Icon, { Icon: MdForward })
					}),
					userFolder !== MAIL_VIEWS.TRASH && /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(Button, {
						subtle: true,
						onClick: async () => {
							await deleteMessage();
							onDeleteMessage?.();
						},
						children: /* @__PURE__ */ jsx(Icon, { Icon: MdDeleteForever })
					}), /* @__PURE__ */ jsx(Button, {
						disabled: updatingUserRead,
						subtle: true,
						onClick: readMessage,
						children: /* @__PURE__ */ jsx(Icon, {
							color: !userRead ? "main" : "",
							Icon: MdMarkAsUnread
						})
					})] }),
					/* @__PURE__ */ jsx(Button, {
						disabled: updatingFlagged,
						subtle: true,
						onClick: flagMessage,
						children: /* @__PURE__ */ jsx(Icon, {
							color: userFlagged ? "caution" : "",
							Icon: HiFlag
						})
					})
				] })]
			}), /* @__PURE__ */ jsx("div", {
				className: "",
				children: /* @__PURE__ */ jsx("h1", {
					className: "text-md font-bold",
					children: subject
				})
			})]
		}),
		mailAction && /* @__PURE__ */ jsxs("div", {
			className: "mt-xxl border-neutral p-sm rounded-xl border",
			ref: actionRef,
			children: [/* @__PURE__ */ jsxs("div", {
				className: "mb-xs inline-flex w-full justify-between",
				children: [/* @__PURE__ */ jsx("h2", {
					className: "text-lg",
					children: mailAction === MailAction.Forward ? "Forward" : "Reply"
				}), /* @__PURE__ */ jsx(Button, {
					className: "mr-1",
					onClick: () => setMailAction(void 0),
					subtle: true,
					variant: "critical",
					children: /* @__PURE__ */ jsx(Icon, { Icon: IoClose })
				})]
			}), /* @__PURE__ */ jsx(MailMessageForm, {
				mailAction,
				initialValues: {
					body: responseData.body,
					bodyHtml: responseData.bodyHtml,
					fileUrls,
					receiverUserAndGroupIds: responseData.recipients,
					subject: `${responseData.subjectPrefix}: ${subject}`,
					threadId
				},
				onComplete: () => {
					setMailAction(void 0);
					onBack?.();
				}
			})]
		}),
		/* @__PURE__ */ jsx(MailMessageThread, {
			beforeMessagesCount: linkedMessages.before,
			afterMessagesCount: linkedMessages.after,
			message: mailMessage,
			threadMessageIds: threadMessagesIds
		})
	] });
};
export { MailMessageDisplay };

//# sourceMappingURL=index.js.map